<template>
    <div>
        <div v-if="!loading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">{{$t("sales_person")}}</h4>
                    <p class="text-subtitle-1">{{$t("sales_person_information")}}</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3" v-if="hasPermission(permissions.sales_person.update)">
                    <v-btn block depressed @click="onEdit">
                        <v-icon left>mdi-pencil</v-icon>
                        {{$t("edit")}}
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn block depressed color="error--text" @click="onRemove" v-if="hasPermission(permissions.sales_person.delete)">
                        <v-icon left>mdi-delete</v-icon>
                        {{$t("delete")}}
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-simple-table
                        dense>
                        <tbody>
                            <tr>
                                <th>{{$t("name")}}</th>
                                <td>{{ data.name }}</td>
                            </tr>
                            <tr>
                                <th>{{$t("user")}}</th>
                                <td>
                                    <span v-if="data && data.user">
                                        {{data.user.first_name}} {{data.user.last_name}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-simple-table
                        dense>
                        <tbody>
                            <tr>
                                <th>{{$t("created_at")}}</th>
                                <td>{{data.created_at}}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <v-col cols="12" md="6">
                    <v-simple-table
                        dense>
                        <tbody>
                            <tr>
                                <th>{{$t("updated_at")}}</th>
                                <td>{{data.updated_at}}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-bind="alert" v-model="alert.display"/>
    </div>
</template>

<script>
import salesPerson from '../../services/sales/salesPerson';
import PAlert from '../../components/common/PAlert.vue';
import authorize from '../../utils/authorize';
import permissions from '../../data/permissions';

export default {
    components: {
        PAlert
    },
    data() {
        return {
            data: {},
            id: null,
            loading: false,
            removeLoading: false,
            alert: {
                display: false,
                content: "Are you sure?",
                callback: null
            },
            permissions
        }
    },
    methods: {
        hasPermission(code) {
            return authorize(code)
        },
        fetch() {
            this.loading = true;
            salesPerson.get(this.id).then(res => {
                this.data = res.data
            }).finally(() => {
                this.loading = false
            })
        },
        onEdit() {
            this.$router.push({
                name: "SalesPersonEdit",
                params: {
                    id: this.id
                }
            })
        },
        onRemove() {
            this.alert = { ...this.alert, display: true, content: this.$t("are_you_sure_remove"), callback: this.remove };
        },
        remove() {
            this.removeLoading = true;
            salesPerson.destroy(this.id).then(() => {
                this.$router.replace({
                    name: "SalesPersonsList"
                })
            }).finally(() => {
                this.removeLoading = false;
            })
        }
    },
    created() {
        this.id = this.$route.params.id;
        this.fetch();
    }
}
</script>

<style>

</style>